import "./style.css";
import { initNav } from "./nav";
import { initSpaceStatus } from "./spaceapi";
import { initEvents } from "./events";
import { initNextEventPreview } from "./next-event";
import { initRevealAnimations } from "./reveal";
import { initAnalytics, optOutAnalytics } from "./analytics";
import { initCookieConsent } from "./consent";
import { initBackToTop } from "./back-to-top";
import { initAccordion } from "./accordion";
import { initCountdown } from "./countdown";
import { initCommandPalette } from "./command-palette";
import { initCopyButtons } from "./copy-button";
import { initServiceWorker } from "./sw-register";

initNav();
initServiceWorker();
initSpaceStatus();
void initEvents();
void initNextEventPreview();
void initCountdown();
initRevealAnimations();
initCookieConsent(initAnalytics, optOutAnalytics);
initBackToTop();
initAccordion();
initCommandPalette();
initCopyButtons();
